class UFilteredListEventTypeSelector extends Uneet {
  constructor (domElement, typeChangeCb) {
    super(domElement)
    this.__typeChangeCb = typeChangeCb
    this.isOpen = false
    this.isUpcoming = true
    this.__init()
  }

  __init () {
    // bind button.mobile-drop-down
    this._e.querySelectorAll('button.mobile-drop-down')[0].onClick((ev) => {
      this.toggleDd()
    })

    // bind both event-type selectors
    this._e.querySelectorAll('button.event-type').forEach((btn) => {
      btn.onClick((ev) => {
        this.toggleType(btn.hasClass('upcoming-events'))
      })
    })
  }

  toggleDd (force) {
    if (force === null) {
      this.isOpen = !this.isOpen
    } else {
      this.isOpen = force
    }

    this._e.toggleClass('isOpen', this.isOpen)
  }

  toggleType (forceUpcoming) {
    const initialIsUpcoming = this.isUpcoming

    if (forceUpcoming === null) {
      this.isUpcoming = !this.isUpcoming
    } else {
      this.isUpcoming = forceUpcoming
    }

    this._e.querySelectorAll('.event-type.selected')[0].removeClass('selected')
    if (this.isUpcoming) {
      this._e.querySelectorAll('.event-type.upcoming-events')[0].addClass('selected')
    } else {
      this._e.querySelectorAll('.event-type.past-events')[0].addClass('selected')
    }

    if (initialIsUpcoming !== this.isUpcoming) {
      this.__onTypeChange(initialIsUpcoming, this.isUpcoming)
    }
  }

  __onTypeChange (oldIsUpcoming, newIsUpcoming) {
    this.__typeChangeCb(oldIsUpcoming, newIsUpcoming)
  }

  getType () {
    return (this.isUpcoming) ? 'upcoming' : 'past'
  }
}
